/****************************************************
 * Module Name:  notificationToAll.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import NotificationProxy from "../../utility/proxy/notification/notificationProxy";
import Utility from "../../utility/utility";
import { Form, Modal } from "react-bootstrap";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { Button } from "@mui/material";
import logo from '../../images/pansuriya.jpg'


export default class NotificationToAll extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newMessage: "",

      userIds: [],
    };

    UserProxy.GetAllGenericUserMini((usersMini) => {
      let lUserIds = [];
      usersMini.map((iUser) => {
        if (iUser.id !== Constants.loggedInUser.id) lUserIds.push(iUser.id);

        return true;
      });

      this.setState({ userIds: lUserIds });
    });
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter") this.sendNotificationToAll();
  };

  sendNotificationToAll = () => {
    let data = {
      fromid: Constants.loggedInUser.id,
      toid: this.state.userIds,
      message: this.state.newMessage,
      messagetime: Utility.GetUTCTime(),
      status: "NEW",
      deleted: false,
    };

    NotificationProxy.AddMultipleNotification(data, (response) =>
      this.props.handleClose(true)
    );
  };

  render() {
    return (
      <Modal show={true} onHide={() => this.props.handleClose(false)} size="lg" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Notification To All
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            placeholder="Send Message to All"
            onKeyDown={this.handleKeyDown}
            onChange={(e) =>
              this.setState({
                newMessage: e.target.value,
              })
            }
            value={this.state.newMessage}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            sx={{
              width: 50,
              mr: 1
            }}
            variant="contained"
            color="primary"
            onClick={() => this.sendNotificationToAll()}
            disabled={this.state.newMessage === "" ? true : false}
          >
            <BsArrowRightCircleFill size="25" />
          </Button>
          <Button
            sx={{
              width: 50,
            }}
            color="error"
            variant="contained"
            onClick={() => this.props.handleClose(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
